import { rgba } from 'polished';
import { Box, Flex } from 'reflexbox';
import styled, { keyframes, useTheme } from 'styled-components';

const animation = keyframes`
    0% { opacity: 0; }
    100% { opacity: 1; }
`;

const Current = styled(Box)<{ value: number; recording?: boolean }>`
	margin-left: 2px;
	width: 4px;
	background: ${(props) =>
		props.recording ? props.theme.colors.danger : props.theme.colors.primary};
	height: ${(props) => props.value * 40}px;
	transform: translateY(${(props) => 20 - props.value * 20}px);
	flex-shrink: 0;
	flex-grow: 0;
	border-radius: 2px;

	transition: 0.1s linear all;
	animation: 0.4s cubic-bezier(0, 1, 0, 1) ${animation};
`;

export default function VoiceMemoWaveForm(props: {
	bars: number[];
	current?: number;
	recording?: boolean;
	progress?: number;
}) {
	const theme = useTheme();
	const dpi = window.devicePixelRatio;

	const width = props.bars.length * 6 - 2;

	return (
		<Flex width={width + (props.current === undefined ? 0 : 6)}>
			<Box flexGrow={0} flexShrink={0}>
				<canvas
					width={width * dpi}
					height={40 * dpi}
					style={{
						display: 'block',
						width,
						height: 40,
					}}
					ref={(ref) => {
						if (!ref) {
							return;
						}

						const ctx = ref.getContext('2d')!;
						ctx.save();
						ctx.scale(dpi, dpi);
						ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

						props.bars.forEach((amplitude, i) => {
							const scaled = Math.max(0.1, Math.round(amplitude * 10) / 10);
							ctx.beginPath();
							ctx.roundRect(6 * i, Math.floor((1 - scaled) * 20), 4, Math.ceil(scaled * 40), 2);
							ctx.fillStyle = props.recording ? theme.colors.danger : theme.colors.primary;

							if (props.progress !== undefined && props.progress <= i / props.bars.length) {
								ctx.fillStyle = rgba(ctx.fillStyle as string, 0.5);
							}

							ctx.closePath();
							ctx.fill();
						});

						ctx.restore();
					}}
				/>
			</Box>
			{props.current !== undefined && (
				<Current key={props.bars.length} value={props.current} recording={props.recording} />
			)}
		</Flex>
	);
}
